import { logEvent } from './analyticsUtils';

const shareAnalytics = () => {

  const ANALYTICS_EVENTS = {    
    ShareCopied: 'copied_share_link',
    ShareReceived: 'received_share_link',
    ShareAccepted: 'accepted_share_link',
    ShareDeclined: 'declined_share_link',
  };

  const logShareCopied = (grantableId, grantableType, shareLink) => {
    logEvent(ANALYTICS_EVENTS.ShareCopied,{
      ugc_id: grantableId,
      ugc_type: grantableType,
      share_id: shareLink,
    });
  };

  const logShareReceived = (feature, shareToken) => {
    logEvent(ANALYTICS_EVENTS.ShareReceived,{
      ugc_id: feature.id,
      ugc_name: feature.title,
      ugc_type: feature.properties.type,
      share_id: shareToken,
    });
  };

  const logShareAccepted = (feature, shareToken) => {
    logEvent(ANALYTICS_EVENTS.ShareAccepted,{
      ugc_id: feature.id,
      ugc_name: feature.title,
      ugc_type: feature.properties.type,
      share_id: shareToken,
    });
  };

  const logShareDeclined = (shareToken) => {
    logEvent(ANALYTICS_EVENTS.ShareDeclined,{
      share_id: shareToken,
    });
  };

  return {
    logShareCopied,
    logShareReceived,
    logShareAccepted,
    logShareDeclined,
  };
};

export default shareAnalytics();